import React from "react";
import "./OpportunityWorkspace.css";

/** Presentation only: callers retain ownership of sources, permissions and actions. */
export function OpportunityWorkspaceHeader({ title, description }: { title: string; description: string }) {
  return <header className="oe-category-header"><span>Opportunity Engine</span><h2>{title}</h2><p>{description}</p></header>;
}

export function OpportunityEmptyState({ title, children, error = false }: { title: string; children: React.ReactNode; error?: boolean }) {
  return <div className="oe-empty-state" role={error ? "alert" : "status"}><h3>{title}</h3><p>{children}</p></div>;
}

export function OpportunityDetailHeader({ title, target, action, children }: { title: string; target?: string | null; action: string; children?: React.ReactNode }) {
  return <header className="oe-detail-context oe-opportunity-context"><span className="oe-eyebrow">Selected opportunity</span><h3>{title}</h3>{target && <p><strong>Target:</strong> {target}</p>}<p><strong>Recommended next step:</strong> {action}</p>{children}</header>;
}
